// AidenBot writes every operator with literal spaces on both sides -- the regexes
// in aiden.Core/ConditionUtil.cs read " and ", " when it's ", " not for ". Anything
// else is part of the operand, so "not for(Bare-OS)" carries no operator at all.
export const isSpaceSurrounded = (text: string, startIndex: number, alias: string): boolean => {
  const endIndex = startIndex + alias.length;

  const beforeChar = startIndex > 0 ? text[startIndex - 1] : "";
  const afterChar = endIndex < text.length ? text[endIndex] : "";

  const isValidBefore = beforeChar === "" || /\s/.test(beforeChar);
  const isValidAfter = afterChar === "" || /\s/.test(afterChar);

  return isValidBefore && isValidAfter;
};
